
(function () {
    'use strict';

    angular.module('app.community', [
        'app.core',
        'app.widgets'
    ]);
})();

